<template>
  <main>
    <h1>Playground</h1>
    <p>This is the place where I experiment with coding with and without help of AI</p>

    <div class="games-container">
      <h2>Games</h2>
      <div class="games-grid">
        <button class="game-card" @click="$emit('change-component', 'ClickingGame')">
          <span class="game-icon">🖱️</span>
          <h3>Clicking Game</h3>
          <p>Click as fast as you can</p>
        </button>

        <button class="game-card" @click="$emit('change-component', 'SnakeGame')">
          <span class="game-icon">🐍</span>
          <h3>Snake Game</h3>
          <p>Classic snake game</p>
        </button>

        <button class="game-card" @click="$emit('change-component', 'ChessGame')">
          <span class="game-icon">♟️</span>
          <h3>Chess Game</h3>
          <p>Play chess against a friend</p>
        </button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Playground',
  emits: ['change-component']
}
</script>

<style scoped>
main {
  padding: 20px;
}

h1 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #333;
}

main > p {
  font-size: 1rem;
  color: #666;
  margin-bottom: 40px;
}

.games-container {
  margin-top: 30px;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #333;
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.game-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 30px 20px;
  border: 2px solid #ddd;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.game-card:hover {
  border-color: #4CAF50;
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.15);
  transform: translateY(-4px);
}

.game-card:active {
  transform: translateY(-2px);
}

.game-icon {
  font-size: 3rem;
  display: block;
}

.game-card h3 {
  font-size: 1.2rem;
  margin: 0;
  color: #333;
}

.game-card p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1.2rem;
  }

  .games-grid {
    grid-template-columns: 1fr;
  }

  .game-card {
    padding: 20px 15px;
  }

  .game-icon {
    font-size: 2.5rem;
  }

  .game-card h3 {
    font-size: 1.1rem;
  }
}
</style>
